import React from 'react';
import { ArticleBlock } from './ArticleBlock';
import styled from '@benzinga/themetron';
import { ErrorBoundary } from '@benzinga/core-ui';
import { ArticleBlock as ArticleBlockType } from '@benzinga/article-manager';

export interface ArticleBlocksProps {
  blocks: ArticleBlockType[];
}

export const ArticleBlocks: React.FC<ArticleBlocksProps> = ({ blocks }) => {
  return (
    <BlocksWrapper>
      {Array.isArray(blocks) &&
        blocks.map((block: ArticleBlockType, i: number) => {
          if (!block) return null;

          const isAdBlock = block?.blockName === 'acf/raptive-ad-placement';
          const fallback = isAdBlock ? <div className="min-h-[250px] w-full" /> : <div />;

          return (
            <ErrorBoundary
              key={`article-blocks-item-wrapper${block?.blockName}-${i}`}
              name={`article-block-${block?.blockName}-${i}`}
            >
              <React.Suspense fallback={fallback}>
                <ArticleBlock block={block} />
              </React.Suspense>
            </ErrorBoundary>
          );
        })}
    </BlocksWrapper>
  );
};

export const BlocksWrapper = styled.div`
  width: 100%;
  figure {
    overflow-x: auto;
    width: 100%;
    margin-bottom: 1rem;
    table {
      white-space: nowrap;
    }
  }
  .block {
    margin: 1rem auto;
    &:first-of-type {
      margin-top: 0;
    }
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  .right {
    float: right;
  }
  .left {
    float: left;
  }
  table {
    text-align: left;
    width: 100%;
    caption {
      font-size: 0.8rem;
      font-weight: ${({ theme }) => theme.fontWeight.bold};
    }
    thead {
      background-color: ${({ theme }) => theme.colorPalette.blue500};
      color: white;
    }
    th,
    td {
      padding: 0.15rem;
      padding-right: 0.5rem;
    }
    tr {
      border-bottom: solid 1px #ddd;
    }
    tbody {
      tr:nth-child(odd) {
        background: #f1f1f1;
      }
    }
  }
  .bz-campaign {
    hr {
      background: #5294c1;
      border: 0;
      height: 1px;
      margin-bottom: 26px;
      padding: 0;
    }
  }
  ul.core-block {
    li {
      padding-bottom: 5px;

      @media (min-width: 600px) {
        padding-bottom: 15px;
      }

      &:last-of-type {
        padding-bottom: 0;
      }
    }
  }
`;
